import { z } from 'zod'

export const companyConfirmationSchema = z.object({
  name: z.string().min(1, 'Názov spoločnosti je povinný'),
  id: z.string().min(1, 'IČO je povinné'),
  vat: z.string().min(1, 'IČ DPH je povinné'),
  vatNumber: z.string().optional(),
  isSoleTrader: z.boolean().refine((val) => val === true, {
    message: 'Označte prosím, že ste živnostník/konateľ spoločnosti',
  }),
  country: z.string().min(1, 'Krajina je povinná'),
  streetAddress: z.string().min(1, 'Ulica je povinná'),
  zipCode: z.string().min(1, 'PSČ je povinné'),
  city: z.string().min(1, 'Mesto je povinné'),
})

export type CompanyConfirmationSchema = z.infer<
  typeof companyConfirmationSchema
>
